<template>
  <div class="biddingViewList">
    <div class="topHead">
      <div class="prdt_hdng">
        <span class="goBackicon" @click="closeActivePopUp()">
          <i id="home-icon" class="material-icons">arrow_back</i>
        </span>
        <span>{{$t('totalUserApplied')}}</span>
      </div>
      <span class="user_count" v-if="totalUser">{{totalUser}} {{$t('people')}}</span>
    </div>
    <div class="innerContent">
      <ul v-if="clickUserList.length">
        <li v-for="(personList, index) in clickUserList" :key="index">
          <span class="img_wrapper">
            <img v-if="personList.profileImage" :src="personList.profileImage" alt="profile-image" />
            <img src="../../../assets/images/dummy.png" alt="profile-image" v-else />
          </span>
          <div class="userdetail">
            <p class="name_time">
              <span class="name">{{personList.userName}}</span>
              <span class="timeAgo">{{personList.displayDate}}</span>
            </p>
            <div v-if="personList.biddingCurrencyType === 'MPOINTS'">
            <span
              class="location"
              v-if="personList.location"
            >{{$t('fromLocationBidPrice',{location:personList.location, biddingValue:personList.biddingValue, currencyType:'MPoints'})}}</span>
            <span
              class="location"
              v-else
            >{{$t('withoutLocationBidPrice',{ biddingValue:personList.biddingValue,currencyType:'MPoints'})}}</span>
            </div>
            <div v-if="personList.biddingCurrencyType === 'GEMS'">
            <span
              class="location"
              v-if="personList.location"
            >{{$t('fromLocationBidPrice',{location:personList.location, biddingValue:personList.biddingValue, currencyType:'Gems'})}}</span>
            <span
              class="location"
              v-else
            >{{$t('withoutLocationBidPrice',{ biddingValue:personList.biddingValue,currencyType:'Gems'})}}</span>
            </div>
          </div>
        </li>
      </ul>
      <infinite-loading
        @infinite="sharedUsersClicked"
        spinner="circles"
        :class="{'visibilityHidden': noData}"
      >
        <template slot="no-results">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
      <div v-if="noShareList && clickUserList.length == 0" class="noDataFound">
        <p>{{$t('noOneHaveBid')}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import ApiCaller from "../../../utils/apicaller";
import constant from "../../../utils/constant";
export default {
  name: "BiddingViewList",
  data() {
    return {
      availableLuckyUserIndex: 0,
      clickUserList: [],
      noData: false,
      noShareList: false,
      totalUser: ""
    };
  },
  methods: {
    closeActivePopUp() {
      this.$emit("closePopUp", false);
    },
    sharedUsersClicked($state) {
      this.loading = true;
      // this.isActivePopUp = true;
      ApiCaller(
        constant.GAMING_API_URL,
        "bid/users/" +
          this.$route.params.saleReferenceID +
          "/" +
          this.availableLuckyUserIndex,
        "get"
      )
        .then(data => {
          this.loading = false;
          this.totalUser = data.data.totalUser;
          if (data.data.biddingUserDTOs.length) {
            this.clickUserList.push(...data.data.biddingUserDTOs);
            this.availableLuckyUserIndex += 1;
            $state && $state.loaded();
          } else {
            this.noData = true;
            this.noShareList = true;
            $state && $state.complete();
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.noDataFound {
  border-radius: 15px;
  width: 80%;
  margin: 25px auto;
  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.15);
  padding: 8px;
  color: dimgray;
  text-align: center;
  p {
    margin: 0;
  }
}
.topHead {
  background: #e81f1f;
  width: 100%;
  text-align: center;
  color: #fff;
  padding: 10px 15px;
  position: relative;
  font-size: 1.05em;
  justify-content: space-between;
  display: flex;
  .prdt_hdng {
    display: flex;
    width: 75%;
    justify-content: flex-start;
    align-items: center;
    .goBackicon {
      padding-right: 5px;
    }
  }
}
.innerContent {
  width: 100%;
  padding: 0px;
  // margin-top: 56px;
  height: calc(100vh - 60px);
  overflow-y: auto;
  padding: 0 15px;
  ul li {
    list-style: none;
    width: 100%;
    display: block;
    position: relative;
    // font-size: 0.875em;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    transition: all ease 0.3s;
    padding: 10px 1% 10px 17%;
    position: relative;
    font-family: Hind, sans-serif;
    .name_time {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 5px;
    }
    .img_wrapper {
      position: absolute;
      left: 0;
      width: 15%;
      display: block;
      img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 50%;
      }
    }
    .userdetail {
      min-height: 35px;
      span {
        display: block;
      }
      .name {
        color: #505050;
        font-weight: 500;
        text-transform: capitalize;
      }
      .location {
        color: #727272;
        font-size: 0.875em;
      }
    }
    &:after {
      content: "";
      width: 82%;
      height: 1px;
      background: #505050;
      position: absolute;
      opacity: 0.6;
    }
  }
}
</style>